// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"230":"3453ab03","403":"9f1c4721","514":"3b4d24e1","594":"564f0560","835":"a7f70add","849":"4c13af48","985":"ae06884b"}[chunkId] + ".css";
};